// M004-F0651 / T-M004-0093 — register the release-freshness worker on every boot,
// authenticated or not, so a returning browser always has a worker whose fetch
// handler re-validates the app shell (public/service-worker.js). Production builds
// only: the CRA dev server and jest never register a worker.
export const SERVICE_WORKER_URL = '/service-worker.js';

export const registerShellServiceWorker = ({
  nav = typeof navigator !== 'undefined' ? navigator : undefined,
  win = typeof window !== 'undefined' ? window : undefined,
  env = process.env.NODE_ENV,
} = {}) => {
  if (env !== 'production' || !nav || !win || !('serviceWorker' in nav) || !win.isSecureContext) {
    return null;
  }

  const register = () => nav.serviceWorker
    .register(SERVICE_WORKER_URL, { scope: '/', updateViaCache: 'none' })
    .then((registration) => registration.update().catch(() => null).then(() => registration))
    .catch((error) => {
      console.error('Failed to register service worker:', error);
      return null;
    });

  if (win.document?.readyState === 'complete') {
    return register();
  }
  win.addEventListener('load', register, { once: true });
  return null;
};
